import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, DateDecoder, StringDecoder, field } from '@simonbackx/simple-encoding';
import { Formatter } from '@stamhoofd/utility';
import { v4 as uuidv4 } from 'uuid';
export class RegistrationPeriodBase extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.customName = null;
        this.startDate = new Date();
        this.endDate = new Date();
        this.locked = false;
        this.previousPeriodId = null;
        this.nextPeriodId = null;
    }
    get name() {
        if (this.customName) {
            return this.customName;
        }
        return $t(`dff05b27-5ad9-416c-b344-f890a4e68255`) + ' ' + Formatter.year(this.startDate) + ' - ' + Formatter.year(this.endDate);
    }
    get nameShort() {
        if (this.customName) {
            return this.customName;
        }
        return Formatter.year(this.startDate) + ' - ' + Formatter.year(this.endDate);
    }
    getDiffValue() {
        return this.name;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], RegistrationPeriodBase.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 383 })
], RegistrationPeriodBase.prototype, "customName", void 0);
__decorate([
    field({ decoder: DateDecoder })
], RegistrationPeriodBase.prototype, "startDate", void 0);
__decorate([
    field({ decoder: DateDecoder })
], RegistrationPeriodBase.prototype, "endDate", void 0);
__decorate([
    field({ decoder: BooleanDecoder, optional: true })
], RegistrationPeriodBase.prototype, "locked", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 354 })
], RegistrationPeriodBase.prototype, "previousPeriodId", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 382 })
], RegistrationPeriodBase.prototype, "nextPeriodId", void 0);
//# sourceMappingURL=RegistrationPeriodBase.js.map